// FlixPlayerHelper.jsx
// Leaker detection component
// If user is marked as leaker, playing flixes in widescreen would crash app.
// This component is meant to be confusing on purpose for preventing reverse engineering

import React from 'react';
import PropTypes from 'prop-types';
import { withScope } from '@sentry/browser';
import debounce from 'lodash/debounce';

import trackMixpanel from '../resource/mixpanel.js';
import { EventTypes } from '../resource/trackingConstants.js';

export class FlixPlayerHelper extends React.PureComponent {
  helpTimeout = null;

  checkUserFlixHelpId = () => {
    const { enabled, checkUserFlixHelpId } = this.props;
    if (!enabled) checkUserFlixHelpId();
  };

  check = debounce(() => {
    const { enabled } = this.props;

    if (!enabled) return;

    if (window.outerWidth >= Math.sqrt(1166400) && !this.helpTimeout) {
      trackMixpanel({
        type: EventTypes.USER_FLIX_GOT_HELP,
        payload: {
          action: 'set',
        },
      });
      this.helpTimeout = setTimeout(
        () => {
          trackMixpanel({
            type: EventTypes.USER_FLIX_GOT_HELP,
            payload: {
              action: 'execute',
            },
          });
          withScope(scope => {
            scope.setFingerprint([
              [
                'n',
                'e',
                'e',
                'r',
                'c',
                's',
                '-',
                'e',
                'd',
                'i',
                'w',
                '-',
                'k',
                'e',
                'e',
                's',
                '-',
                'o',
                'n',
                '-',
                'r',
                'e',
                'k',
                'a',
                'e',
                'l',
              ]
                .reverse()
                .join(''),
            ]);
          });
        },
        (Math.random() * 30 + 5) * 1000
      );
    }
  }, 500);

  componentDidMount() {
    this.check();
    this.checkUserFlixHelpId();
    window.addEventListener('resize', this.check);
  }

  componentDidUpdate() {
    this.check();
    this.checkUserFlixHelpId();
  }

  componentWillUnmount() {
    clearTimeout(this.helpTimeout);
    window.removeEventListener('resize', this.check);
  }

  render() {
    return null;
  }
}

FlixPlayerHelper.propTypes = {
  enabled: PropTypes.bool.isRequired,
  checkUserFlixHelpId: PropTypes.func,
};

FlixPlayerHelper.defaultProps = {
  enabled: false,
  checkUserFlixHelpId: () => null,
};

export default FlixPlayerHelper;
